import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SnackbarService } from '@awread/global/packages';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  standalone: true,
  selector: 'excerpt-form-atom',
  imports: [ReactiveFormsModule, CommonModule, FontAwesomeModule],
  templateUrl: './excerpt-form.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExcerptFormAtom implements OnInit {
  @Input() ui!: any;
  faIcon = faTrash;
  constructor(private cd: ChangeDetectorRef, private snackbarService: SnackbarService) {}

  ngOnInit(): void {}

  get textsControl() {
    return this.ui.bookForm.get('texts') as FormArray;
  }

  addTextControl() {
    this.textsControl.push(new FormControl(''));
    this.cd.detectChanges();
    this.snackbarService.showSuccess('Thêm trích đoạn thành công');
  }

  deleteTextControl(index: number) {
    this.snackbarService.openConfirm('Bạn có chắc chắn muốn xóa trích đoạn này?').afterClosed$.subscribe((result: any) => {
      if (result) {
        this.textsControl.removeAt(index);
        this.cd.detectChanges();
        this.snackbarService.showSuccess('Xóa trích đoạn thành công');
      }
    });
  }
}
